import { useTranslation } from 'react-i18next';

const EmojisNotAllowedMessage = () => {
    const { t } = useTranslation();

    return (
        <div className='flex items-start my-2 p-2 bg-red-100 max-w-[83.59%] text-red-700 rounded-sm border border-red-400'>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 mr-2 text-red-600"
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
            </svg>
            <p className='mb-0 text-sm text-red-700 font-medium'>{t('ui_spear.generalAlerts.smt_doesnt_support_emojis_v3')}</p>
        </div>
    );
};

export default EmojisNotAllowedMessage;